// Simplified-Chinese strings for the library area. Keys are the exact English source strings.
export const library: Record<string, string> = {
  // Collections
  'Collections · Pinpoint': '合集 · Pinpoint',
  'Collections': '合集',
  'No collections yet — group videos from your': '还没有合集 — 从你的视频库中分组视频',
  'Library': '视频库',
  'Collection': '合集',
  'video': '个视频',
  'videos': '个视频',
  'Delete this collection?': '删除这个合集？',
  'This collection is empty. Add videos by dragging them onto it in your': '这个合集是空的。在你的视频库中将视频拖拽到它上面以添加',
  'Delete collection': '删除合集',

  // Add-video drawer (iteration 0014)
  'Add a video': '添加视频',
  'Add video': '添加视频',
  'Drop video files here, or choose files': '将视频文件拖到这里，或选择文件',
  'They queue below — nothing uploads until you click Upload.': '它们会在下方排队 — 点击「上传」前不会上传任何内容。',
  'Queued': '排队中',
  'Failed': '失败',
  'Canceled': '已取消',
  '{count} queued': '{count} 个排队中',
  'Upload {count}': '上传 {count} 个',
  'Clear list': '清空列表',
  'Remove': '移除',

  // Watch later (iteration 0014)
  'Watch later': '稍后观看',
  'Later': '稍后',
  'Saved — remove': '已保存 — 移除',
  'Nothing saved for later yet.': '还没有保存任何稍后观看的内容。',
  'Nothing here yet — add a video with the button above.': '这里还没有内容 — 用上方的按钮添加视频。',
  'Couldn’t update Watch later.': '无法更新稍后观看。',
  'Add the video you copied?': '要添加你刚复制的视频吗？',
  'Dismiss': '关闭',

  // Athletes
  'Athletes · Pinpoint': '运动员 · Pinpoint',
  'Athletes': '运动员',
  'People featured across your videos.': '出现在你视频中的人物。',
  'New athlete': '新运动员',
  'Add': '添加',
  'No athletes yet. Add one above, or assign athletes from a video page.': '还没有运动员。在上方添加，或从视频页面指派运动员。',
  '{count} {label} featuring this athlete': '{count} {label}出现了该运动员',
  'Change photo': '更换照片',
  'Add photo': '添加照片',
  'No videos yet. Assign this athlete from a video page.': '还没有视频。从视频页面指派该运动员。',
  'Upload a file': '上传文件',
  'or': '或',
  'Paste an image URL…': '粘贴图片链接…',
  'Attach': '附加',
  'Remove photo': '移除照片',

  // Shares
  'Shared with you': '分享给你',
  'Save to my workspace': '保存到我的工作区',
  'A private, independent copy will be added to your current workspace.': '一份私有的独立副本将被添加到你当前的工作区。',
  'Share': '分享',
  'Copied!': '已复制！',
  'Copy link': '复制链接',
  'Unshare': '取消分享',
}
